import { Routes, Route, Navigate } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Search from "@/pages/Search";
import HotelDetail from "@/pages/HotelDetail";
import Booking from "@/pages/Booking";
import Payment from "@/pages/Payment";
import MyBookings from "@/pages/MyBookings";
import MyInquiries from "@/pages/MyInquiries";
import HostDashboard from "@/pages/HostDashboard";
import HostProperties from "@/pages/HostProperties";
import HostPropertyEdit from "@/pages/HostPropertyEdit";
import HostBookings from "@/pages/HostBookings";
import HostInquiries from "@/pages/HostInquiries";
import HostSubscription from "@/pages/HostSubscription";
import Services from "@/pages/Services";
import ProviderDashboard from "@/pages/ProviderDashboard";
import AdminPanel from "@/pages/AdminPanel";
import CancellationPolicy from "@/pages/CancellationPolicy";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { useAuth } from "@/contexts/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#717171]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#717171]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#222222]">
      <Header />
      <main className="flex-1 pt-20">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/search" element={<Search />} />
          <Route path="/hotel/:id" element={<HotelDetail />} />
          <Route path="/book/:hotelId/:roomId" element={<Booking />} />
          <Route path="/payment/:bookingId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
          <Route path="/inquiries" element={<ProtectedRoute><MyInquiries /></ProtectedRoute>} />
          <Route path="/host" element={<ProtectedRoute><HostDashboard /></ProtectedRoute>} />
          <Route path="/host/properties" element={<ProtectedRoute><HostProperties /></ProtectedRoute>} />
          <Route path="/host/properties/:id" element={<ProtectedRoute><HostPropertyEdit /></ProtectedRoute>} />
          <Route path="/host/properties/new" element={<ProtectedRoute><HostPropertyEdit /></ProtectedRoute>} />
          <Route path="/host/bookings" element={<ProtectedRoute><HostBookings /></ProtectedRoute>} />
          <Route path="/host/inquiries" element={<ProtectedRoute><HostInquiries /></ProtectedRoute>} />
          <Route path="/services" element={<Services />} />
          <Route path="/provider" element={<ProtectedRoute><ProviderDashboard /></ProtectedRoute>} />
          <Route path="/host/subscription" element={<ProtectedRoute><HostSubscription /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
